// @flow
import actionTypes from '../../actionTypes';
import { fetch } from '../../../api';
import { getAsyncHashImage } from './uploadImage';
import formatComposeData from './formatComposeData';

type EditData = {
  id: IdType,
  body: string,
  isPrivate: boolean,
  isUploading: any,
  title: string,
  author: User,
  postImageHash?: string,
}

export function failEditingPostAction(id: IdType, message: string, error: any) {
  return {
    type: actionTypes.POST_EDIT_FAILURE,
    error,
    isAsynchronous: true,
    alert: {
      type: actionTypes.POST_EDIT_FAILURE,
      alertType: 'warning',
      message,
      postId: id,
    },
  };
}

export function succeedEditingPostAction(post: Post) {
  return {
    type: actionTypes.POST_EDIT_SUCCESS,
    data: { posts: [post] },
    isAsynchronous: true,
  };
}

export default (data: EditData) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const { localData, queryData, commonData } = formatComposeData(data, state);
    const oldPost = state.data.posts[data.id];

    let post;
    try {
      const postImageHash = await getAsyncHashImage(data.isUploading, localData.id, dispatch) || data.postImageHash;
      const body = { ...commonData, ...queryData, id: data.id, postImageHash };

      const result = await fetch('post', { method: 'PUT', body: JSON.stringify(body) });
      post = result.payload.post;
    } catch (error) {
      return dispatch(failEditingPostAction(data.id, oldPost.title, error));
    }

    return dispatch(succeedEditingPostAction(post));
  };
};



// WEBPACK FOOTER //
// ./~/virgo/src/actions/dataActionsCreator/posts/edit.js